(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("iview/locale", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["iview/locale"] = factory(require("vue"));
	else
		root["iview/locale"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/locale/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (lang) {
    if (!isServer) {
        if (typeof window.iview !== 'undefined') {
            if (!('langs' in iview)) {
                iview.langs = {};
            }
            iview.langs[lang.i.locale] = lang;
        }
    }
};

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isServer = _vue2.default.prototype.$isServer;

;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lang = __webpack_require__(0);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lang = {
    i: {
        locale: 'fi-FI',
        select: {
            placeholder: 'Valitse',
            noMatch: 'Ei tuloksia',
            loading: 'Ladataan'
        },
        table: {
            noDataText: 'Ei tietoja',
            noFilteredDataText: 'Ei suodatettua dataa',
            confirmFilter: 'Hyväksy',
            resetFilter: 'Nollaa',
            clearFilter: 'Kaikki'
        },
        datepicker: {
            selectDate: 'Valitse päivämäärä',
            selectTime: 'Valitse aika',
            startTime: 'Aloitusaika',
            endTime: 'Päättymisaika',
            clear: 'Tyhjennä',
            ok: 'OK',
            datePanelLabel: '[mmmm] [yyyy]',
            month: 'Kuukausi',
            month1: 'Tammikuu',
            month2: 'Helmikuu',
            month3: 'Maaliskuu',
            month4: 'Huhtikuu',
            month5: 'Toukokuu',
            month6: 'Kesäkuu',
            month7: 'Heinäkuu',
            month8: 'Elokuu',
            month9: 'Syyskuu',
            month10: 'Lokakuu',
            month11: 'Marraskuu',
            month12: 'Joulukuu',
            year: 'Vuosi',
            weekStartDay: '1',
            weeks: {
                sun: 'Su',
                mon: 'Ma',
                tue: 'Ti',
                wed: 'Ke',
                thu: 'To',
                fri: 'Pe',
                sat: 'La'
            },
            months: {
                m1: 'Tam',
                m2: 'Hel',
                m3: 'Maa',
                m4: 'Huh',
                m5: 'Tou',
                m6: 'Kes',
                m7: 'Hei',
                m8: 'Elo',
                m9: 'Syy',
                m10: 'Lok',
                m11: 'Mar',
                m12: 'Jou'
            }
        },
        transfer: {
            titles: {
                source: 'Lähde',
                target: 'Kohde'
            },
            filterPlaceholder: 'Hae täältä',
            notFoundText: 'Ei tuloksia'
        },
        modal: {
            okText: 'OK',
            cancelText: 'Peruuta'
        },
        poptip: {
            okText: 'OK',
            cancelText: 'Peruuta'
        },
        page: {
            prev: 'Edellinen sivu',
            next: 'Seuraava sivu',
            total: 'Yhteensä',
            item: 'kohde',
            items: 'kohdetta',
            prev5: 'Edelliset 5 sivua',
            next5: 'Seuraavat 5 sivua',
            page: '/page',
            goto: 'Siirry',
            p: ''
        },
        rate: {
            star: 'Tähti',
            stars: 'Tähteä'
        },
        time: {
            before: ' sitten',
            after: ' jälkeen',
            just: 'juuri nyt',
            seconds: ' sekuntia',
            minutes: ' minuuttia',
            hours: ' tuntia',
            days: ' päivää'
        },
        tree: {
            emptyText: 'Ei tietoja'
        }
    }
};

(0, _lang2.default)(lang);

exports.default = lang;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// fi-FI.js